import { useQuery } from "@tanstack/react-query";
import apiFetch from "../../utils/apiFetch";
import { authHeaders } from "./helpers";
import type { Employee } from "./types";

export function useEmployees(locationId: string | undefined, enabled: boolean) {
  return useQuery<Employee[]>({
    queryKey: ["work-location-employees", locationId],
    queryFn: async () => {
      const res = await apiFetch("/api/v1/payroll/employees", {
        headers: authHeaders(),
      });
      if (!res.ok) throw new Error("Could not load employees.");
      const data = await res.json();
      const list: Employee[] = Array.isArray(data)
        ? data
        : data.items || data.employees || [];
      return list.filter(
        (e) => e.status !== "inactive" && e.status !== "terminated"
      );
    },
    enabled,
    refetchOnWindowFocus: false,
  });
}